import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  inject,
  input,
  OnInit,
  QueryList,
  signal,
  ViewChildren,
} from '@angular/core';
import { MenuItemsServiceService } from '../../Services/menu-items.service.service';
import { SingleMenuItem } from '../../models/Customer Order model/single-menu-item.model';
import { ExchangeConvertorService } from '../../Services/exchange-convertor.service';
import { LanguageService } from '../../Services/language.service';

@Component({
  selector: 'app-menu-item-card',
  templateUrl: './menu-item-card.component.html',
  styleUrl: './menu-item-card.component.scss',
})
export class MenuItemCardComponent implements AfterViewInit, OnInit {
  //from menuitems page
  MenuItemID = input.required<number>();
  menuItemService = inject(MenuItemsServiceService);
  menuItem!: SingleMenuItem;
  private cdr = inject(ChangeDetectorRef);
  isActive = false;
  description = signal<string>('');
  inputDescription = '';

  //exchange Rate
  amountInUSD: number = 0;
  exchangeRate: number | null = null;
  public languageService = inject(LanguageService);
  language = this.languageService.getLanguage();

  constructor(private currencyConverterService: ExchangeConvertorService) {
  }

  ngOnInit(): void {
    this.languageService.currentLanguage$.subscribe(() => {
      this.updateTitles();
    });
    this.menuItemService.getMenuItem(this.MenuItemID()).subscribe({
      next: (response) => {
        this.menuItem = response;
        this.fetchExchangeRate();
        this.trimInput();
      },
      error: (err) => {
      //  console.log(err);
      },
    });
  }

  fetchExchangeRate(): void {
    this.languageService.currentLanguage$.subscribe((langauge) => {
      switch(langauge){
        case "En":
          this.currencyConverterService.calculateDollar(this.menuItem.priceEn).subscribe({
            next: (priceInUSD) => {
              this.amountInUSD = priceInUSD;
            },
            error: (error) => {
              //console.error('Error calculating dollar value:', error);
            },
          });
         break;
        case "Tr":
          this.currencyConverterService.calculateDollar(this.menuItem.priceTr).subscribe({
            next: (priceInUSD) => {
              this.amountInUSD = priceInUSD;
            },
            error: (error) => {
              //console.error('Error calculating dollar value:', error);
            },
          });
         break;
        case "Ar":
          this.currencyConverterService.calculateDollar(this.menuItem.priceAr).subscribe({
            next: (priceInUSD) => {
              this.amountInUSD = priceInUSD;
            },
            error: (error) => {
              //console.error('Error calculating dollar value:', error);
            },
          });
         break;
      }
    })
  }

  //for animation
  @ViewChildren('container') containers!: QueryList<ElementRef>; // Query all containers
  ngAfterViewInit(): void {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active');
            entry.target.classList.remove('inactive');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
  
    const observeContainers = () => {
      this.containers.forEach((container) => {
      //  console.log('Observing container:', container.nativeElement);
        observer.observe(container.nativeElement);
      });
    };
  
    // Observe initially
    observeContainers();
  
    // Re-observe when containers change
    this.containers.changes.subscribe(() => {
  //    console.log('Containers updated. Re-observing...');
      observeContainers();
    });
  }
  
  
  updateTitles() {
    this.language = this.languageService.getLanguage();
    this.cdr.detectChanges(); // Ensure the DOM updates
    this.fetchExchangeRate();
    setTimeout(() => {
      this.isActive = true;
    }, 50);
  }

  trimInput(): void {
    this.languageService.currentLanguage$.subscribe(() => {
      if (this.language == 'Ar') {
        this.inputDescription = this.menuItem.descriptionAr;
      } else if (this.language == 'En') {
        this.inputDescription = this.menuItem.descriptionEn;
      } else {
        this.inputDescription = this.menuItem.descriptionTr;
      }

      // Set the current value of description to input_item_description
      this.description.set(this.inputDescription);

      // Check the length and trim if necessary
      if (this.description().length > 55) {
        // Use () to access the signal value
        this.description.set(this.description().substring(0, 55) + '....'); // Trim to 30 characters
      }
    });
  }
}
